const post = {
  id: "openFOI",
  title: "Automating Freedom of Information Requests",
  publication: "Portfolio, 2025",
  date: "2025-05-28",
  summary: "An AI-powered platform for managing Freedom of Information requests.",
  content: `

## OpenFOI

Freedom of Information (FOI) requests are vital for transparency and accountability, yet responding to them remains manually intensive and error-prone. OpenFOI is a streamlined, AI-powered tool for managing FOI workflows end-to-end. Built for journalists, public officials, and civil society organizations, it simplifies response drafting, redaction, export, and request tracking, all in a single interface.

### Features

- GPT-powered response drafting with integrated FOI exemptions
- Manual and rule-based redaction with exemption tagging
- Blackout-style redacted PDF + styled DOCX export
- CSV upload for batch request ingestion
- Request tracker with metadata, reference numbers, and response history
- Session-based state saving for seamless navigation
- Customisable exemptions system compliant with UK FOI Act 2000

### Reflections

Tony Blair reportedly called pushing through the FOI Act one of his biggest regrets in government, arguing it bred a risk-averse culture in the civil service. There's something worth sitting with there: if the tool designed to hold institutions accountable also makes them more cautious and less effective, the tradeoff is less obvious than it first appears. FOI compliance costs the UK government tens of millions of pounds a year. Whether that money is well spent depends entirely on what you think transparency is for.

[View on GitHub](https://github.com/macaswalker/openFOI)
`
};

export default post;
